export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setinvoicePeriods(state, invoicePeriods) {
    state.invoicePeriods = invoicePeriods;
  },
  setForm(state, form) {
    state.form = form;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/client-environment/pages/invoice-extract/store/mutations.js